export default "__VITE_ASSET__7b87f8c1__"